import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Problem, Question, Symptom } from "@kiddocare-platform/portal-common/hub";

export class HubConfigurationService extends BaseService {

  public async GetProblem(isAiEnabled: boolean): Promise<ResponseMessage<Array<Problem>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/config/getProblem/${isAiEnabled}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetProblems", error.stack, JSON.stringify(error));
      throw error;
    }
  };

  public async SymptomByProblemPatient(
    idAccountPatient: bigint,
    idProblem: bigint,
    isAiEnabled?: boolean
  ): Promise<ResponseMessage<Array<Symptom>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/config/symptomByProblemPatient/${idAccountPatient}/${idProblem}/${isAiEnabled}`);
      return response.data;
    } catch (error: any) {
      this.log.error("symptomByProblemPatient", error.stack, JSON.stringify(error));
      throw error;
    }
  };

  public async GetQuestionsByIdSymptoms(data: {
    ids: Array<bigint>;
    idAccountPatient: bigint;
  }): Promise<ResponseMessage<Array<Question>>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/config/getQuestionsByIdSymptoms`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("GetQuestionsByIdSymptoms", error.stack, JSON.stringify(error));
      throw error;
    }
  };

}